function checkSoapGift() {
  const settings = window.freeSoapGiftSettings;
  if (!settings || !settings.enabled) return;

  let soapQty = 0;
 
  document.querySelectorAll('.cart-item.soap-product').forEach(item => {
    const qty = parseInt(item.getAttribute('data-quantity')) || 0;
    soapQty += qty;
  });

  console.log('Total Soap Quantity:', soapQty);

  const giftVariantId = settings.variantId;
  let cartUpdates = {};
 
  let giftInCart = false;
  document.querySelectorAll('.cart-item').forEach(item => {
    if (item.dataset.variantId === giftVariantId) {
      giftInCart = true;
    }
  });

  if (soapQty >= settings.requiredSoapCount && !giftInCart) {
    cartUpdates[giftVariantId] = 1;
  } else if (soapQty < settings.requiredSoapCount && giftInCart) {
    cartUpdates[giftVariantId] = 0;
  } else {
    return;
  }

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: { updates: cartUpdates },
    dataType: 'json',
    success: function (res) {
      console.log('Gift Updated');
      new_updateCartDrawer();
    }
  });
}



function checkAndUpdateFreeGift() {
  const settings = window.freeGiftSettings;
  if (!settings || !settings.enabled) return;

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartItems = cart.items;
      const cartTotal = cart.total_price;
      let qtyInTheCart = 0;
      let cartUpdates = {};
 
      for (let i = 0; i < cart.items.length; i++) {
        if (Number(cart.items[i].id) === Number(settings.variantId)) {
          qtyInTheCart = cart.items[i].quantity;
          break;
        }
      }

      console.log('Cart total:', cartTotal);
      console.log('Gift quantity:', qtyInTheCart);
      console.log('Threshold:', settings.threshold);
 
      if (qtyInTheCart > 0 && cartTotal < settings.threshold) {
        cartUpdates[settings.variantId] = 0;
      } 
      else if (qtyInTheCart === 0 && cartTotal >= settings.threshold) {
        cartUpdates[settings.variantId] = 1;
      } else {
        return;  
      }
 
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates },
        dataType: 'json',
        success: function (updatedCart) {
          if (typeof new_updateCartDrawer === 'function') {
            new_updateCartDrawer();
          } else {
            location.reload(); // fallback
          }
        }
      });
    });
}


function new_updateCartDrawer() {
  fetch(`${Shopify.routes.cart_url}?section_id=cart-drawer`)
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const cartDrawer = document.querySelector('.drawer');
      const newContent = html.querySelector('#CartDrawer');

      if (cartDrawer && newContent) {
        const newInner = newContent.querySelector('.drawer__inner'); 

        if (newInner) {
          cartDrawer.querySelector('.drawer__inner').innerHTML = newInner.innerHTML;
        } 

        cartDrawer.classList.remove('is-empty');
        cartDrawer.classList.add('active');
      }
    })
    .catch(e => console.error('❌ Error updating cart drawer:', e));
}

function minfunctioncart() {
  var ctc = jQuery("#main-cart-footer .totals__subtotal-value")
    .html()
    .replace(/[^\d\.]/g, "");
  var ctpr = "200";
  if (ctc > ctpr) {
    jQuery("#main-cart-footer .minimum-order-notice").hide(); 
    jQuery("#main-cart-footer button#checkout").show();
  } else {
    jQuery("#main-cart-footer .minimum-order-notice").show(); 
    jQuery("#main-cart-footer button#checkout").hide();
  }
  console.log('check 1 ', ctc);
}
function minfunction() {
  var ct = jQuery(".drawer__footer .totals__subtotal-value")
    .html()
    .replace(/[^\d\.]/g, "");
  var ctpr = "200";
  if (ct > ctpr) {
    jQuery(".drawer__footer .minimum-order-notice").hide();
    jQuery(".drawer__footer button#CartDrawer-Checkout").show(); 
  } else {
    jQuery(".drawer__footer .minimum-order-notice").show();
    jQuery(".drawer__footer button#CartDrawer-Checkout").hide(); 
  }
  console.log(ct);
}
setTimeout(function () {
 
  minfunctioncart();
  minfunction();
}, 1000);

setTimeout(() => {
     checkAndUpdateFreeGift();
     checkSoapGift();
  }, 1500);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
      var _this2 = this;
    
    this.addEventListener("click", (event) => {
      event.preventDefault();
      var _this = this;
      if(this.hasAttribute("custombox")){
              $.ajax({
              type: "POST",
              url: '/cart/clear.js',
              data: '',
              dataType: 'json',
              success: function() { 
               const cartItems =
        _this.closest("cart-items") || _this.closest("cart-drawer-items");
      cartItems.updateQuantity(_this.dataset.index, 0);
              },
              error: function(XMLHttpRequest, textStatus) {
              /* error code */
              }
              });
      }else{

        if(this.hasAttribute("remove_token")){
         var i = $(this).attr("remove_token"), H = {};
        var cartwhich = ["cart-drawer","cart-icon-bubble"];
     if(window.location.pathname == "/cart"){
    $("cart-items .cart-item").each(function(C) {
      if($(this).attr("gen_token") != ""){
        var L = $(this).attr("gen_token"),
            U = $(this).attr("data-cart-item-id");
        if(i == L){
          H[U] = 0;
        }
      }
      cartwhich = [
    "template--16182951805137__cart-items",
    "cart-icon-bubble",
    "cart-live-region-text",
    "template--16182951805137__cart-footer"
     ];
      
    });
     }else{
        $(".cart-item").each(function(C) {
        if($(this).attr("gen_token") != ""){
        var L = $(this).attr("gen_token"),
            U = $(this).attr("data-cart-item-id");
        if(i == L){
          H[U] = 0;
        }
        }
        });
     }
     setTimeout(() => {
    $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: {
            updates: H,
            sections: cartwhich,
            sections_url: window.location.pathname,
        },
        dataType: "json",
        success: function(C) {
           
          if(window.location.pathname == "/cart"){
            var cartd = document.querySelector('cart-items');
            //      cart.renderContents(C);
            //      cart.classList.remove('is-empty');
                 
            // console.log("Hooray!", C)

          const parsedState = C;
        cartd.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-items");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );
                  _this2.getSectionsToRender2().forEach((section) => {
                    const elementToReplace =
                      document
                        .getElementById(section.id)
                        .querySelector(section.selector) ||
                      document.getElementById(section.id);
                    elementToReplace.innerHTML = cartd.getSectionInnerHTML(
                      parsedState.sections[section.section],
                      section.selector
                    );
                  });
          
          }else{
            var cartd = document.querySelector('cart-drawer');
            //      cart.renderContents(C);
            //      cart.classList.remove('is-empty');
                 
            // console.log("Hooray!", C)

          const parsedState = C;
        cartd.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );
              _this2.getSectionsToRender().forEach((section) => {
                    const elementToReplace =
                      document
                        .getElementById(section.id)
                        .querySelector(section.selector) ||
                      document.getElementById(section.id);
                    elementToReplace.innerHTML = cartd.getSectionInnerHTML(
                      parsedState.sections[section.section],
                      section.selector
                    );
                  });
          }
          
        },
        error: function(C) {
            console.error("Booo!", C)
        }
    });
     }, 1000);
        }else{
        const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
        }
      }
    
    });
     
  }
 
  getSectionsToRender() {
    return [
      
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner"
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section"
       }
    ];
    
  }

  getSectionsToRender2() {
     return [
      
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
    
    
  }
 
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    var checkattra = $(event.target).parents(".cart-item")[0];
    
    console.log(checkattra);
     if(checkattra.hasAttribute("gen_token") && event.target.value == '0'){
         var i = $(checkattra).attr("gen_token"), H = {};
        var cartwhich = ["cart-drawer","cart-icon-bubble"];
     if(window.location.pathname == "/cart"){
    $("cart-items .cart-item").each(function(C) {
      if($(this).attr("gen_token") != ""){
        var L = $(this).attr("gen_token"),
            U = $(this).attr("data-cart-item-id");
        if(i == L){
          H[U] = 0;
        }
      }
      cartwhich = [
    "template--16182951805137__cart-items",
    "cart-icon-bubble",
    "cart-live-region-text",
    "template--16182951805137__cart-footer"
     ];
      
    });
     }else{
        $(".cart-item").each(function(C) {
        if($(this).attr("gen_token") != ""){
        var L = $(this).attr("gen_token"),
            U = $(this).attr("data-cart-item-id");
        if(i == L){
          H[U] = 0;
        }
        }
        });
     }
     setTimeout(() => {
    $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: {
            updates: H,
            sections: cartwhich,
            sections_url: window.location.pathname,
        },
        dataType: "json",
        success: function(C) {
           
          if(window.location.pathname == "/cart"){
            var cartd = document.querySelector('cart-items');
            //      cart.renderContents(C);
            //      cart.classList.remove('is-empty');
                 
            // console.log("Hooray!", C)

          const parsedState = C;
        cartd.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-items");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );
                  _this2.getSectionsToRender2().forEach((section) => {
                    const elementToReplace =
                      document
                        .getElementById(section.id)
                        .querySelector(section.selector) ||
                      document.getElementById(section.id);
                    elementToReplace.innerHTML = cartd.getSectionInnerHTML(
                      parsedState.sections[section.section],
                      section.selector
                    );
                  });
          
          }else{
            var cartd = document.querySelector('cart-drawer');
            //      cart.renderContents(C);
            //      cart.classList.remove('is-empty');
                 
            // console.log("Hooray!", C)

          const parsedState = C;
        cartd.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );
              _this2.getSectionsToRender().forEach((section) => {
                    const elementToReplace =
                      document
                        .getElementById(section.id)
                        .querySelector(section.selector) ||
                      document.getElementById(section.id);
                    elementToReplace.innerHTML = cartd.getSectionInnerHTML(
                      parsedState.sections[section.section],
                      section.selector
                    );
                  });
          }
          
        },
        error: function(C) {
            console.error("Booo!", C)
        }
    });
     }, 1000);
        }else{
        const cartItems =
        this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
        }
   
  }

  getSectionsToRender() {
    return [
      
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
    
  }

  updateQuantity(line, quantity, name) {
    setTimeout(function () {
      minfunctioncart(); 
    }, 2000);
    setTimeout(() => {
       checkAndUpdateFreeGift();
       checkSoapGift();
    }, 2100);
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      lineItemError.querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
 setTimeout(function () {
      minfunction();
    }, 10);
    setTimeout(() => {
    checkAndUpdateFreeGift();
    checkSoapGift();
  }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
   
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
    
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300)
        );
      }
    }
  );
}